/**
 * AllExceptionsFilter on the API wraps every error as
 * `{ success: false, error: { message, tag, code, field? } }`, so the message
 * lives at `data.error.message` — never at `data.message`. The bare `data.message`
 * form is kept as a fallback for anything not routed through that filter
 * (proxy errors, static hosts).
 */
type ApiErrorBody = {
  error?: { message?: string | string[]; field?: string };
  message?: string | string[];
};
type AxiosLike = { response?: { data?: ApiErrorBody }; message?: string };

/** class-validator sends `message` as a string[]; banners want one line. */
function flatten(m?: string | string[]): string | undefined {
  return Array.isArray(m) ? m.join(', ') : m;
}

/** Form field the API blamed, when it sends one (e.g. duplicate email/phone conflicts). */
export function getErrorField(e: unknown): string | undefined {
  return (e as AxiosLike)?.response?.data?.error?.field;
}

export function getErrorMsg(e: unknown, fallback = 'An error occurred'): string {
  const data = (e as AxiosLike)?.response?.data;
  return (
    flatten(data?.error?.message) ||
    flatten(data?.message) ||
    (e as AxiosLike)?.message ||
    fallback
  );
}
